<template>
  <div class="zyc-content">
    <div class="zyc-content-t-l"></div>
    <div class="zyc-content-t-r"></div>
    <div class="zyc-content-b-l"></div>
    <div class="zyc-content-b-r"></div>
    <div class="zyc-content-c">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  /**
  * 内容容器
  */
  export default {
    name: 'zycContent',
    props: {
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/contentContainer.vue